import React from 'react'
import styled from 'styled-components'
import { string, func, bool, oneOfType, number } from 'prop-types'
import { Link } from 'gatsby'

import { pricify } from 'utils/pricify'

import * as spacing from 'styles/spacing'
import { white, greyDark, borderColor, offWhite } from 'styles/colors'
import { media } from 'styles/media'
import { borderRadius } from 'styles/global'
import { H3, fontWeights, fontSizes } from 'styles/typography'
import Button from 'components/button/Button'

const Container = styled.div`
  position: sticky;
  bottom: 0;
  padding: ${spacing.large};
  background-color: ${white};
  border-top: 1px solid ${borderColor};
  width: 100%;
  z-index: 20;

  ${media.medium`
    padding: ${spacing.large} ${spacing.xLarge};
    height: auto;
  `};

  ${media.large`
    padding-top: ${spacing.xLarge};
    padding-bottom: ${spacing.xLarge};
  `};

  ${media.xLarge`
    padding: ${spacing.xxLarge} ${spacing.large};
  `};
`

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${spacing.medium};

  ${media.small`
    justify-content: center;
  `};

  ${media.small`
    justify-content: space-between;
  `};

  &:last-child {
    margin-bottom: 0;
  }

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};
`

const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  ${media.medium`
    max-width: 660px;
  `};
`

const StyledButton = styled(Button)`
  min-width: 180px;
  margin-left: ${spacing.large};

  ${media.medium`
    width: 200px;
  `};

  ${media.large`
    width: 280px;
  `};

  ${media.xLarge`
    width: 320px;
  `};
`

const Price = styled(H3)`
  font-weight: ${fontWeights.bold};
  margin-bottom: 0;
`

const Disclaimer = styled.div`
  display: inline-block;
  border-radius: ${borderRadius};
  background-color: ${offWhite};
  padding: ${spacing.small} ${spacing.medium};
  color: ${greyDark};
  font-size: ${fontSizes.small};
  text-align: center;

  a {
    font-weight: ${fontWeights.bold};
  }
`

const Summary = ({ handleSubmit, loading, orderType, disabled, price }) => {
  const isSubscription = orderType === 'subscription'

  return (
    <Container>
      <Inner>
        <ButtonWrap>
          {price !== null && <Price>{`${pricify({ amount: price })}${isSubscription ? '/month' : ''}`}</Price>}
          <StyledButton theme="primary" type="button" onClick={handleSubmit} disabled={disabled} isLoading={loading}>
            {isSubscription ? 'Subscribe & Save' : 'Add to cart'}
          </StyledButton>
        </ButtonWrap>
        {isSubscription && (
          <Disclaimer>
            You can cancel or pause your subscription whenever you like.{' '}
            <Link to="/subscribe/">
              <a>Learn more</a>
            </Link>
          </Disclaimer>
        )}
      </Inner>
    </Container>
  )
}

Summary.propTypes = {
  handleSubmit: func,
  loading: bool,
  disabled: bool,
  orderType: string,
  price: oneOfType([string, number])
}

export default Summary
